function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { setHOCDisplayName } from '@domain-group/fe-helper';
import { childContextTypes } from './ad-root';
import { jsx as ___EmotionJSX } from "@emotion/core";

var withAdControl = function withAdControl(WrappedComponent) {
  var WithAdControl = function WithAdControl(props, context) {
    return ___EmotionJSX(WrappedComponent, _extends({}, props, context));
  };

  WithAdControl.contextTypes = childContextTypes;
  setHOCDisplayName(WithAdControl, WrappedComponent, 'withAdControl');
  return WithAdControl;
};

export default withAdControl;